export const SEARCH_HIGHLIGHT_COLOR = 0x2693ff;
export const MUTED_ELEMENT_ALPHA = 0.4;
